import Transformer from './transformer';
import stringUtil from '../utils/stringUtil';
// import numberUtil from '../utils/number';
// import date from '../utils/dateTime';

export default class VoucherOrderTransformer extends Transformer {
  static fetch(voucher) {
    return {
      id: voucher.id,
      by: voucher.sender_email,
      to: voucher.email,
      unit_value: voucher.unit_value,
      quantity: voucher.quantity,
      status: voucher.status,
      gateway: voucher.payment_type,
      approver: voucher.admin ? voucher.admin.email : '',
      created: voucher.created_at,
    };
  }

  static fetchForTable(voucher) {
    return {
      id: voucher.id,
      by: voucher.sender_email,
      to: voucher.email,
      unit_value: voucher.unit_value,
      quantity: voucher.quantity,
      status: voucher.status,
      gateway: voucher.payment_type,
      approver: voucher.admin ? voucher.admin.email : '',
      created: voucher.created_at,
    };
  }

  static status(one) {
    return stringUtil.capitalize(one.status);
  }
  static gateway(one) {
    if (one.gateway) return stringUtil.capitalize(one.gateway.replace(/[^a-zA-Z 0-9]+/g, ' '));
    else return '-';
  }

  static useBy(one) {
    if (one.useBy) return `${one.useBy.email} \n(Support pin : ${one.useBy.support_pin})`;
    else return '-';
  }
}

export const voucherOrderMixin = {
  methods: {
    gateway: VoucherOrderTransformer.gateway,
  },
};
